<div *ngIf="showInfo" class="open-form-info radius-ai padding-medium margin-top-medium" [ngClass]="infoClass">
  <h4 *ngIf="info.heading" class="margin-bottom-xsmall">{{ info.heading }}</h4>

  <div *ngIf="type === 'object' && info.content && info.content.length" class="raptor-info-content-array">
    <div *ngFor="let content of info.content; index as i;" [hidden]="content.hidden" class="raptor-info-content-item">
      <div class="raptor-info-content-badge" *ngIf="content.caption">
        <span class="text-capsule medium strong-small">{{ content.caption }}</span>
      </div>
      <div class="raptor-info-content-icon" *ngIf="content.icon">
        <open-svg-icon name="{{ content.icon }}" class="small"></open-svg-icon>
      </div>
      <div class="raptor-info-content-copy">
        <h4 *ngIf="content.heading">{{ content.heading }}</h4>
        <p *ngIf="content.text">{{ content.text }}</p>
      </div>
      <span *ngIf="content.help && (!content.help.type || content.help.type === 'tooltip')" class="tooltip">
        <open-tooltip [tooltipContent]="content.help.content"></open-tooltip>
      </span>

      <open-raptor-call-to-action *ngIf="content.cta" [componentDetails]="content.cta"></open-raptor-call-to-action>

      <mat-accordion *ngIf="content.accordion && content.accordion.length" [ngClass]="{ 'single-accordion': content.accordion.length === 1 }">
        <mat-expansion-panel *ngFor="let item of content.accordion">
          <mat-expansion-panel-header>
            <mat-panel-title><strong>{{ item.title }}</strong></mat-panel-title>
          </mat-expansion-panel-header>
          <div [innerHTML]="item.content"></div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>

  <div *ngIf="type === 'html'" [innerHTML]="info.content | sanitizedHtml" class="formatted-info"></div>
</div>
